module.exports = __webpack_public_path__ + "static/media/E4.62a27a2d.jpg";